export const TRACKING_ID = 'G-8MZM375M30'; // TRACKING_ID for GTM
